import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-reviews',
    templateUrl: './reviews.component.html',
    styleUrls: ['./reviews.component.scss'],
    imports: [TranslateModule],
})
export class ReviewsComponent implements OnInit {
  magnetImages: string[] = ['e.webp', '1.webp', '4.webp', 'g.webp', 'b.webp', '2.webp', '3.webp', 'f.webp'];

  // Reviews data for the new design
  reviews = [
    {
      text: 'HOME.REVIEWS.REVIEW_3_TEXT',
      name: 'Jana Spirkovska',
      job: 'HOME.REVIEWS.REVIEW_3_JOB',
      avatar: '../../assets/images/female-review.svg'
    },
    {
      text: 'HOME.REVIEWS.REVIEW_1_TEXT',
      name: 'Abhishek Mishra',
      job: 'HOME.REVIEWS.REVIEW_1_JOB',
      avatar: '../../assets/images/walsdorf.svg'
    },
    {
      text: 'HOME.REVIEWS.REVIEW_2_TEXT',
      name: 'Sai Rasam',
      job: 'HOME.REVIEWS.REVIEW_2_JOB',
      avatar: '../../assets/images/kempinski.svg'
    },
    {
      text: 'HOME.REVIEWS.REVIEW_4_TEXT',
      name: 'Anastasija Risteska',
      job: 'HOME.REVIEWS.REVIEW_4_JOB',
      avatar: '../../assets/images/female-review.svg'
    },
    {
      text: 'HOME.REVIEWS.REVIEW_5_TEXT',
      name: 'Nikolina Mizich',
      job: 'HOME.REVIEWS.REVIEW_5_JOB',
      avatar: '../../assets/images/esc-room.svg'
    }
  ];

  constructor() { }

  ngOnInit(): void {
  }

}
